import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function InquiryListPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [inquiries, setInquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const password = searchParams.get('pasword') || searchParams.get('password');
  const fromDate = searchParams.get('from');
  const toDate = searchParams.get('to');

  useEffect(() => {
    if (password !== '786') {
      setLoading(false);
      return;
    }

    const fetchInquiries = async () => {
      try {
        const response = await fetch('/api/inquiries.php');
        if (!response.ok) throw new Error('Failed to fetch inquiries');
        const data = await response.json();
        
        let filtered = data.data || [];

        if (fromDate) {
          const from = new Date(fromDate);
          filtered = filtered.filter(i => new Date(i.submittedAt) >= from);
        }
        
        if (toDate) {
          const to = new Date(toDate);
          to.setHours(23, 59, 59, 999);
          filtered = filtered.filter(i => new Date(i.submittedAt) <= to);
        }
        
        setInquiries(filtered);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchInquiries();
  }, [password, fromDate, toDate]);

  if (password !== '786') {
    return (
      <div className="container" style={{ padding: '100px 20px', textAlign: 'center', minHeight: '60vh' }}>
        <h2 style={{ color: '#cc0000', marginBottom: '15px' }}><i className="fa fa-ban"></i> Access Denied</h2>
        <p>Invalid password provided in the URL.</p>
      </div>
    );
  }

  return (
    <div className="container" style={{ padding: '60px 20px', minHeight: '80vh' }}>
      <h2 style={{ marginBottom: '20px', fontWeight: 700, color: 'var(--color-primary, #2400A8)' }}>
        <i className="fas fa-list-alt" style={{ marginRight: '10px' }}></i>
        Inquiry List
      </h2>

      <form onSubmit={(e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const from = formData.get('from');
        const to = formData.get('to');
        
        const newParams = new URLSearchParams(searchParams);
        newParams.set('filter', 'date');
        if (from) newParams.set('from', from); else newParams.delete('from');
        if (to) newParams.set('to', to); else newParams.delete('to');
        
        setSearchParams(newParams);
      }} style={{ marginBottom: '20px', padding: '15px 20px', background: '#f8f9fa', borderRadius: '8px', border: '1px solid #ddd', display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'wrap' }}>
        <strong><i className="fa fa-filter"></i> Filter by Date:</strong>
        
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <label htmlFor="from" style={{ fontSize: '0.9rem', color: '#666' }}>From</label>
          <input type="date" name="from" id="from" defaultValue={fromDate || ''} style={{ padding: '6px 10px', borderRadius: '4px', border: '1px solid #ccc' }} />
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <label htmlFor="to" style={{ fontSize: '0.9rem', color: '#666' }}>To</label>
          <input type="date" name="to" id="to" defaultValue={toDate || ''} style={{ padding: '6px 10px', borderRadius: '4px', border: '1px solid #ccc' }} />
        </div>

        <button type="submit" style={{ padding: '7px 15px', background: 'var(--color-primary, #2400A8)', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>
          Apply Filter
        </button>

        {(fromDate || toDate) && (
          <button type="button" onClick={() => {
            const newParams = new URLSearchParams(searchParams);
            newParams.delete('from');
            newParams.delete('to');
            newParams.delete('filter');
            setSearchParams(newParams);
            document.getElementById('from').value = '';
            document.getElementById('to').value = '';
          }} style={{ padding: '7px 15px', background: '#e0e0e0', color: '#333', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '0.9rem' }}>
            Clear
          </button>
        )}
      </form>

      {loading ? (
        <div style={{ textAlign: 'center', padding: '60px' }}>
          <i className="fa fa-spinner fa-spin fa-3x" style={{ color: 'var(--color-primary, #2400A8)' }}></i>
          <p style={{ marginTop: '15px', color: '#555' }}>Loading inquiries...</p>
        </div>
      ) : error ? (
        <div style={{ color: '#cc0000', padding: '20px', background: '#fff2f2', border: '1px solid #ffcccc', borderRadius: '6px' }}>
          <i className="fa fa-exclamation-circle"></i> {error}
        </div>
      ) : inquiries.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px', background: '#f8f9fa', borderRadius: '8px', border: '1px dashed #ccc' }}>
          <i className="fa fa-inbox fa-3x" style={{ color: '#ccc', marginBottom: '15px' }}></i>
          <h4 style={{ color: '#555' }}>No inquiries found</h4>
          <p style={{ color: '#777' }}>There are no inquiries matching the current criteria.</p>
        </div>
      ) : (
        <div style={{ overflowX: 'auto', background: '#fff', borderRadius: '8px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', minWidth: '800px' }}>
            <thead>
              <tr style={{ background: 'var(--color-primary, #2400A8)', color: '#fff' }}>
                <th style={{ padding: '16px', borderBottom: '2px solid rgba(0,0,0,0.1)' }}>Date</th>
                <th style={{ padding: '16px', borderBottom: '2px solid rgba(0,0,0,0.1)' }}>Name / Contact</th>
                <th style={{ padding: '16px', borderBottom: '2px solid rgba(0,0,0,0.1)' }}>Subject</th>
                <th style={{ padding: '16px', borderBottom: '2px solid rgba(0,0,0,0.1)' }}>Service / Package</th>
                <th style={{ padding: '16px', borderBottom: '2px solid rgba(0,0,0,0.1)' }}>Est. Price</th>
              </tr>
            </thead>
            <tbody>
              {inquiries.map((inq) => (
                <tr key={inq.id} style={{ borderBottom: '1px solid #eee', transition: 'background 0.2s' }} onMouseOver={(e) => e.currentTarget.style.background = '#f9f9ff'} onMouseOut={(e) => e.currentTarget.style.background = 'transparent'}>
                  <td style={{ padding: '16px', fontSize: '0.9rem', whiteSpace: 'nowrap', verticalAlign: 'top' }}>
                    <div style={{ fontWeight: 600, color: '#333' }}>{new Date(inq.submittedAt).toLocaleDateString()}</div>
                    <div style={{ color: '#777', fontSize: '0.8rem' }}>{new Date(inq.submittedAt).toLocaleTimeString()}</div>
                  </td>
                  <td style={{ padding: '16px', verticalAlign: 'top' }}>
                    <div style={{ fontWeight: 600, color: '#222' }}>{inq.name}</div>
                    <div style={{ fontSize: '0.85rem', color: '#666', marginTop: '4px' }}>
                      <i className="fa fa-phone" style={{ fontSize: '0.75rem', marginRight: '4px' }}></i> {inq.mobile}
                    </div>
                    {inq.email && (
                      <div style={{ fontSize: '0.85rem', color: '#666', marginTop: '2px' }}>
                        <i className="fa fa-envelope" style={{ fontSize: '0.75rem', marginRight: '4px' }}></i> {inq.email}
                      </div>
                    )}
                  </td>
                  <td style={{ padding: '16px', verticalAlign: 'top' }}>
                    <div style={{ fontWeight: 600, color: '#333' }}>{inq.subject}</div>
                    {inq.message && (
                      <div style={{ fontSize: '0.85rem', color: '#666', marginTop: '6px', maxWidth: '300px', lineHeight: '1.4' }}>
                        {inq.message}
                      </div>
                    )}
                  </td>
                  <td style={{ padding: '16px', verticalAlign: 'top' }}>
                    <div style={{ fontSize: '0.8rem', color: '#666', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{inq.service}</div>
                    <div style={{ fontWeight: 600, color: '#333', marginTop: '2px' }}>{inq.package}</div>
                  </td>
                  <td style={{ padding: '16px', fontWeight: 700, color: 'var(--color-primary, #2400A8)', verticalAlign: 'top', whiteSpace: 'nowrap' }}>
                    {inq.estimatedPrice}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
